import { render, staticRenderFns } from "./whyKtng.vue?vue&type=template&id=319bd319&scoped=true"
import script from "./whyKtng.vue?vue&type=script&lang=js"
export * from "./whyKtng.vue?vue&type=script&lang=js"
import style0 from "./whyKtng.vue?vue&type=style&index=0&id=319bd319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319bd319",
  null
  
)

export default component.exports